/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import BenefitsLegalbirdTech from "./BenefitsLegalbirdTech";
import SendApplication from "./SendApplication";
import { gaSet } from "@/src/services/googleAnalyticsService";
import JobContainer, { JobContainerProps } from "@/src/components/Jobs/Job/JobContainer";

const productManagerJobDetails: JobContainerProps = {
  title: "Product Manager Legal Tech (m/w/d)",
  hardFacts: [
    {
      title: "Standort",
      value: "Köln, DE",
    },
    {
      title: "Beschäftigungsart",
      value: "Vollzeit",
    },
    {
      title: "Arbeitsmodell",
      value: "Hybrid",
    },
    {
      title: "Bereich",
      value: "Product",
    },
  ],
  content: [
    {
      type: "text",
      text:
        "Mit unserer starken Onlinekompetenz, hoher juristischer Expertise und innovativer, AI-gestützter Automatisierung helfen wir dabei, rechtliche " +
        "Fragestellungen sicher, schnell und professionell online zu lösen.",
    },
    {
      type: "text",
      text:
        "Du hast Lust auf ein stark wachsendes Unternehmen und darauf, den Rechtsberatungsmarkt mit Hilfe modernster digitaler Technologien zu verändern? Du " +
        "ziehst es vor, in einem produktiven Umfeld zu arbeiten, in dem Du Projekte selbstverantwortlich in die Hand nehmen kannst? Du schätzt eine offene " +
        "Atmosphäre, in der es Spaß macht, über sich hinauszuwachsen? Dann bewirb Dich bei uns!",
    },
    {
      type: "headline",
      headline: "Was Deine Aufgaben sein werden",
    },
    {
      type: "text",
      text:
        "Du bist zuständig für die Servicewelt des Kunden und für unser eigenes CRM-System zur Mandantenbetreuung und sorgst dafür, dass alles Hand-in-Hand " +
        "funktioniert. Dazu gehört:",
    },
    {
      type: "list",
      items: [
        "Die Entwicklung neuer Features in Zusammenarbeit mit unserem Legal-Team und der IT",
        "Die Optimierung des eigenen CRM-Systems für unsere internen und externen Anwälte",
        "Das Erstellen von Tickets in Jira und die Priorisierung des Backlogs",
      ],
    },
    {
      type: "headline",
      headline: "Was Du dazu brauchst",
    },
    {
      type: "list",
      items: [
        "Du hast Spaß am Software-Produktmanagement und bestenfalls Vorerfahrung von mindestens 1-2 Jahren",
        "Du hast ein gutes Gefühl für Nutzer-Bedürfnisse und übernimmst gerne Verantwortung für dein Produkt und die Umsetzung neuer Features",
        "Du liebst alles rund um AI im privaten und beruflichen Kontext und brennst dafür, diese je nach Use-Case optimal und kreativ einzusetzen",
        "Du hast schon mit Jira/Atlassian gearbeitet und kommunizierst gerne direkt mit der IT",
        "Vorerfahrung im Rechtsbereich wäre zwar schön, ist aber nicht notwendig",
      ],
    },
  ],
  afterContent: (
    <>
      <BenefitsLegalbirdTech />
      <SendApplication to={"Melanie Treude"} />
    </>
  ),
};

const ProductManager = () => {
  const title = "Jobs - Rechtsanwältin/Rechtsanwalt | Legalbird";

  gaSet({ title: title });

  return (
    <LayoutPublicRoutes>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <JobContainer {...productManagerJobDetails} />
    </LayoutPublicRoutes>
  );
};

export default ProductManager;
